import React,{ useState, useEffect }from "react";
import MyCount from "../../../components/MyPage/MyCount";
import PaginationSection from "../../../components/Product/Pagination";
import { MY_PAGE_COUPON_LIST_URL } from "../../../utils/urls";
import instance from "../../../services/services";
import { useLanguage } from "../../../hooks/useLanguage";


function CouponList(){
  const { t } = useLanguage();
  const [isTablet, setIsTablet] = useState(false);
  const [couponList, setCouponList] = useState([]);
  const itemsPerPage = 12;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);



    // 모바일 체크
    useEffect(() => {
      const checkTablet = () => {
        setIsTablet(window.innerWidth < 768);
      };
      
      checkTablet();
      window.addEventListener('resize', checkTablet);
      
      return () => window.removeEventListener('resize', checkTablet);
    }, []);

    useEffect(() => {
      const fetchCouponList = async () => {
        const response = await instance.post(MY_PAGE_COUPON_LIST_URL,{
          offset: 1,
          limit: itemsPerPage,
        });
        setCouponList(response.data.data.data);
        setTotalCount(response.data.data.total_count);
      }
      fetchCouponList();
    }, []);

    const handlePageChange = (page) => {
      setCurrentPage(page);
      window.scrollTo(0, 0);
    };
  
    const handleArrowClick = (page) => {
      handlePageChange(page);
    };
    
    
  
  return(
    <div>
      <div>
        {/* 장바구니 / 관심상품 / 쿠폰 */}
        {!isTablet && <MyCount/>}
      </div>
      <div className="my_container">
        <div className="order_title">
          <h3>{t('coupon')}</h3>
        </div>

        {/* 데이터 없을때 */}
        {couponList.length === 0 ? (
          <div className="default_info_table no_data text_center pt_48">
            {t('coupon_list_empty')}
          </div>
        ) : (
          <div className="coupon_list">
            <ul className="coupon_con">
              {/* 리스트 12개 표출 */}
              {couponList.map((item, index) => (
                <li className="coupon_item flex-12 column" key={index}>
                  <div className="flex-4 column">
                  <p className="p2 red">
                    {item?.coupon_val}{item?.price_type_name} {t('coupon')}
                  </p>
                  <span className="b1-1">
                    {item?.coupon_name}
                  </span>
                </div>
                <div>
                  <span className="b2-2 g-80">
                    {item?.use_start_date.split(' ')[0]} ~ {item?.use_end_date.split(' ')[0]}
                  </span>
                </div>
                </li>
              ))}
            </ul>

            
            <PaginationSection
              totalCount={totalCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              onArrow={handleArrowClick}
          />

          </div>
        )}

      </div>

      {/* 쿠폰 안내 */}
      <div className="alert_box gray">
        <h6 className="strong_b1">{t('coupon_info')}</h6>
        <p className="px-4 dash_list flex-2 column">
          <span className="guide_text_1 g-80">
            {t('coupon_info_2')}
          </span>
          <span className="guide_text_1 g-80">
            {t('coupon_info_3')}
          </span>
          <span className="guide_text_1 g-80">
            {t('coupon_info_4')}
          </span>
          <span className="guide_text_1 g-80">
            {t('coupon_info_5')}
          </span>
          <span className="guide_text_1 g-80">
            {t('coupon_info_6')}
          </span>
          <span className="guide_text_1 g-80">
            {t('coupon_info_7')}
          </span>
          <span className="guide_text_1 g-80">
            {t('coupon_info_8')}
          </span>
        </p>
      </div>  

    </div>
  )
};

export default CouponList;